export const TABLE_ROW_NAV_IGNORE_SELECTOR =
  "button,a,input,textarea,select,label,mat-checkbox,mat-radio-button,mat-slide-toggle,mat-select,mat-menu,mat-menu-panel,.mat-mdc-menu-panel,.mat-mdc-checkbox,.mat-mdc-slide-toggle,.mat-mdc-select,.cdk-overlay-pane,.table-actions,.table-row-actions,[data-table-no-row-nav]";

export function isTableRowNavIgnoredTarget(
  target: EventTarget | null,
): boolean {
  if (!(target instanceof Element)) {
    return true;
  }
  return Boolean(target.closest(TABLE_ROW_NAV_IGNORE_SELECTOR));
}

export function shouldOpenTableRowInNewTab(event: MouseEvent): boolean {
  return event.ctrlKey || event.metaKey || event.button === 1;
}
